// The two ways out of the web app into making music.
//
// Remix in Ableton: the landing site's download page (seed-bed.com, not in
// this repo). `seed` rides along so that page can say which seed brought you
// and, once the extension can take a deep link, open it; `ref` tells the
// landing site's analytics the visit came from the web app.
//
// Audiotool: the seed's Audiotool page, which finds the projects already linked
// to the seed on your Audiotool account and offers a new one (the export page,
// from main, #42); and the upload page, which brings a project back as a seed.

export const DOWNLOAD_PAGE = "https://seed-bed.com/download";

export function remixInAbletonUrl(seedId: string): string {
  const url = new URL(DOWNLOAD_PAGE);
  url.searchParams.set("seed", seedId);
  url.searchParams.set("ref", "web");
  return url.toString();
}

export function audiotoolExportPath(seedId: string): string {
  return `/export/audiotool/${encodeURIComponent(seedId)}`;
}

export function audiotoolHubPath(seedId: string): string {
  return `/s/${encodeURIComponent(seedId)}/audiotool`;
}

/** Upload an Audiotool project as a seed — as a new version of `parent` when given. */
export function audiotoolUploadPath(opts: { project?: string; parent?: string } = {}): string {
  const q = new URLSearchParams();
  if (opts.project) q.set("project", opts.project);
  if (opts.parent) q.set("parent", opts.parent);
  const qs = q.toString();
  return `/upload/audiotool${qs ? `?${qs}` : ""}`;
}

/** Upload a folder or zip of audio from any DAW — as a remix of `parent` when given. */
export function filesUploadPath(opts: { parent?: string } = {}): string {
  return opts.parent ? `/upload/files?parent=${encodeURIComponent(opts.parent)}` : "/upload/files";
}

/** Solo browser remix — local editing, no auth required. */
export function localRoomPath(seedId: string): string {
  return `/room/local/${encodeURIComponent(seedId)}`;
}

/** A jam room — connected to a jam's Durable Object. */
export function roomPath(jamId: string): string {
  return `/room/${encodeURIComponent(jamId)}`;
}

export function seedPath(seedId: string): string {
  return `/s/${encodeURIComponent(seedId)}`;
}

export function profilePath(handle: string): string {
  return `/@${encodeURIComponent(handle)}`;
}

/** A blank room: a seed made from nothing, in the browser. */
export function newRoomPath(): string {
  return "/room/new";
}

/** A seed being made in this browser and not yet saved. */
export function draftRoomPath(draftId: string): string {
  return `/room/draft/${encodeURIComponent(draftId)}`;
}

/** An event's page (Secret Sample). */
export function eventPath(slug: string): string {
  return `/events/${encodeURIComponent(slug)}`;
}

/**
 * Upload a new seed for an event's pool: seeds only, pooled and back to the
 * event when done. `then`: the Join step to resume there (mid-Join).
 */
export function eventUploadPath(slug: string, then?: "discord"): string {
  return `/upload/files?event=${encodeURIComponent(slug)}${then ? `&then=${then}` : ""}`;
}
